module.exports = __webpack_public_path__ + "static/fonts/NanumSquareNeoTTF-eHv.b15fcd7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NanumSquareNeoTTF-eHv.woff
// module id = O12W
// module chunks = 0